<template>
  <div class="add-fields-modal">
    <a-modal
      :centered="true"
      :title="`${formDisabled ? '查看' : (nowObj?'编辑':'新增')}订阅任务`"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      width="900px"
    >
      <a-form-model
        ref="form"
        :disabled="formDisabled"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="任务名称" prop="name" :rules="[
          { required: true, message: '请输入任务名称', trigger: 'blur' },
          { max: 50, message: '不能超过50个字符', trigger: 'blur' },
          { validator: validatorName, trigger: 'blur' },
        ]">
          <a-input v-model="form.name" placeholder="请输入任务名称" :disabled="formDisabled"/>
        </a-form-model-item>
        <a-form-model-item label="订阅状态" prop="status" >
          <a-switch  :disabled="formDisabled" v-model="form.status" />
        </a-form-model-item>
        <a-form-model-item label="分析模型"  placeholder="请选择也支持关键字搜索"
         prop="templateId" :rules="[{ required: true, message: '请选择分析模型', trigger: 'change' }]">
          <a-select :disabled="formDisabled" :showSearch="true" :filter-option="false" v-model="form.templateId" placeholder="请选择分析模型" @search="searchModel">
            <a-select-option :value="v.analysisTemplateId" v-for="v in tableList" :key="v.analysisTemplateId">{{v.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="订阅时间" style="margin-bottom: 0;" required>
          <a-row :gutter="20" >
            <a-col :span="8">
            <a-form-model-item prop="execFrequency" :rules="[{ required: true, message: '请选择订阅频次', trigger: 'change' }]">
              <a-select :disabled="formDisabled" v-model="form.execFrequency" placeholder="请选择频次" @change="changeFrequency">
                <a-select-option :value="v.value" v-for="(v, index) in FrequencyList" :key="index">{{v.name}}</a-select-option>
              </a-select>
            </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if="form.execFrequency !== 'EVERY_DAY'&&form.execFrequency !== 'EVERY_HOUR'">
              <a-form-model-item prop="execDate" :rules="[{ required: true, message: '请选择星期/日期', trigger: 'change' }]">
                <a-select :disabled="formDisabled" v-model="form.execDate" placeholder="请选择星期/日期">
                  <a-select-option v-for="(v, index) in dateList" :key="index" :value="v.value" >{{v.name}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item prop="execMinute" :rules="[{ required: true, message: '请选择订阅时间', trigger: 'change' }]" v-if="form.execFrequency === 'EVERY_HOUR'">
                <a-time-picker :disabled="formDisabled" v-model="form.execMinute" format="ss" valueFormat="ss"/>
              </a-form-model-item>
              <a-form-model-item prop="execTime[0]" :rules="[{ required: true, message: '请选择订阅时间', trigger: 'change' }]" v-else>
                  <a-time-picker :disabled="formDisabled" v-model="form.execTime[0]" format="HH:mm" valueFormat="HH:mm"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model-item>
        <a-row v-if="form.execFrequency === 'EVERY_HOUR'">
          <a-col :span="10">
            <a-form-model-item label="提醒时间" prop="dateType"
              :rules="{ required: true, message: '请输入提醒内容', trigger: 'blur',}"
              :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }"
            >
              <!-- <div v-if="formDisabled">{{form.dateType === '2'?'定时':'全天'}}</div> -->
              <a-radio-group name="dateType" v-model="form.dateType" :disabled="formDisabled">
                <a-radio value="1">全天</a-radio>
                <a-radio value="2">定时</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="10" class="hour-range" v-if="form.dateType === '2'">
            <a-select :disabled="formDisabled" v-model="form.dateStart" @change="dateStartChange" style="width: 60px;" :showArrow="false" :dropdownMatchSelectWidth="false">
              <a-select-option v-for="item in hourList" :key="item">{{item}}</a-select-option>
            </a-select>
            <span class="split-icon">~</span>
            <a-select :disabled="formDisabled" v-model="form.dateEnd" style="width: 60px" :showArrow="false" :dropdownMatchSelectWidth="false">
              <template v-for="item in hourList">
                <a-select-option :key="item" v-if="disableEndDate(item)">{{item}}</a-select-option>
              </template>
            </a-select>
            <a-popover placement="top">
              <template slot="content">超出当前时间范围，则不会生成订阅任务。eg.8-10点，则11点不会生成时报。</template>
              <icon-font type="icon-Question-Circle-Line"></icon-font>
            </a-popover>
          </a-col>
        </a-row>
        <a-form-model-item label="订阅通知" prop="receivers.emailCheck" :rules="[{ required: true, message: '请选择订阅通知', trigger: 'change' }]">
          <a-row>
            <a-col :span="3">
              <a-checkbox :disabled="formDisabled" v-model="form.receivers.emailCheck">邮件</a-checkbox>
            </a-col>
            <a-col :span="19">
               <a-form-model-item prop="receivers.emails"
               :rules="[
                  { required: form.receivers.emailCheck ? true : false, message: '请填写邮箱，以逗号分隔', trigger: 'blur',},
                  { validator: validatorEmails, trigger: 'blur',}
                ]"
            >
              <a-input :disabled="formDisabled || !form.receivers.emailCheck" v-model="form.receivers.emails" placeholder="请填写邮箱，以逗号分隔"></a-input>
            </a-form-model-item>
            </a-col>
            <a-col :span="2">
              <span style="margin-left: 10px;">{{emailsNum}}</span>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="3">
              <a-checkbox :disabled="formDisabled" v-model="form.receivers.feishuEmailCheck" >飞书</a-checkbox>
            </a-col>
            <a-col :span="19">
              <a-form-model-item prop="receivers.feishuEmails"
               :rules="[
                  { required: form.receivers.feishuEmailCheck ? true : false, message: '请填写飞书邮箱，以逗号分隔', trigger: 'blur',},
                  { validator: validatorFeiShuEmails, trigger: 'blur',}
                ]"
            >
              <a-input :disabled="formDisabled || !form.receivers.feishuEmailCheck" v-model="form.receivers.feishuEmails" placeholder="请填写邮箱，以逗号分隔"></a-input>
            </a-form-model-item>
            </a-col>
            <a-col :span="2">
              <span style="margin-left: 10px;">{{feishuEmailsNum}}</span>
            </a-col>
          </a-row>
        </a-form-model-item>
        
      </a-form-model>
      <div slot="footer" v-if="formDisabled"></div>
    </a-modal>
  </div>
</template>
<script>
import { getAnalysisTemplates } from '@/api/template'
import { getChartSubDetail, addChartSub, updateChartSub } from "@/api/chartSub"
// import matchFieldList from "./actionTypes"
const initForm = {
        name: '',
        status: false,
        templateId: undefined,
        execFrequency: undefined,
        execDate: undefined,
        execTime:[],
        execMinute: undefined,
        dateStart: '08:00',
        dateEnd: '22:00',
        dateType: '1',
        receivers: {
          emailCheck: false,
          emails: '',
          feishuEmailCheck: false,
          feishuEmails: '',
        },       
      }
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      formDisabled: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
      FrequencyList: [
        {
          name: '每小时',
          value: 'EVERY_HOUR'
        },
        {
          name: '每天',
          value: 'EVERY_DAY'
        },
        {
          name: '每周',
          value: 'EVERY_WEEK'
        },
        {
          name: '每月',
          value: 'EVERY_MONTH'
        },
      ],
      
      MonthList: [
       
      ],
      dateList:[],
      form: this.$deepclone(initForm),
      
      tableList: [],
      nowObj: null,

      hourList: [],
    };
  },
  props: ['code'],
  computed: {
    emailsNum() {
      let warningInformUser = this.form.receivers.emails
      let arr = warningInformUser.split(',').filter(v => v)
      return `${arr.length}个`
    },
    feishuEmailsNum() {
      let warningInformUser = this.form.receivers.feishuEmails
      let arr = warningInformUser.split(',').filter(v => v)
      return `${arr.length}个`
    }
  },
  mounted() {
    this.getModelList();
    // findRecordsetByCode({
    //   code: this.code
    // }).then((res) => {
    //   this.tableList = res.data || []
    // })
    let arr = []
    for (let i = 0; i < 25; i++) {
      let str = i<10?`0${i}:00`:`${i}:00`
      arr.push(str)
    }
    this.hourList = arr
  },
  methods: {
    disableEndDate(endDate) {
      return Number(this.form.dateStart.slice(0,2)) <= Number(endDate.slice(0, 2))
    },
    dateStartChange() {
      if(Number(this.form.dateStart.slice(0,2)) > Number(this.form.dateEnd.slice(0, 2))) {
        this.form.dateEnd = this.form.dateStart
      }
    },
    searchModel(val){
      this.fetchModel(val);
    },
    fetchModel(val) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.getModelList(val);
      }, 500);
    },
    getModelList(searchKeyWord) {
      this.loading = true
      getAnalysisTemplates({
        pageSize: 20,
        pageNo: 1,
        searchKeyWord
      }).then((res) => {
        this.tableList = this.$deepclone(res.data.recordList) || []
      }).finally(() => this.loading = false)
    },
    changeEmail(name){
      this.form.receivers[name] = !!!this.form.receivers[name]
    },
    validatorName(rule, value, callback) {
      if(!/^[\a-\z\A-\Z0-9\u4e00-\u9fe5\-\_]+$/.test(value)) {
        callback(new Error('只能输入中英文数字'))
      } else {
        callback()
      }
    },
    changeFrequency(val){
      this.form.execDate = undefined;
      if(val === 'EVERY_WEEK'){
        this.dateList = this.$enum.WeekList;
      }else if(val === 'EVERY_MONTH'){
        this.dateList = this.$enum.GetMonthList();
        console.log(this.dateList, 'dateList')
      }
    },
    init(isDisabled, data) {
      this.visible = true
      this.formDisabled = isDisabled;
      this.$nextTick(() => {
        if(data) {
          this.nowObj = data
          console.log(data)
          const params = {
            id: data.id
          }
          getChartSubDetail(params).then((res) => {
            const odata = res.data
            const { name, status, templateId, execFrequency, execDate, execTime,
             receivers, id, execMinute, execInterval } = odata;
            this.form.name = name;
            this.form.status = status;
            this.form.templateId = templateId;
            this.form.execFrequency = execFrequency;
            this.changeFrequency(execFrequency);
            this.form.execDate = execDate;
            this.form.execTime = execTime;
            this.form.receivers = receivers;
            this.form.execMinute = execMinute,
            this.form.id = id;
            let exec = execInterval?execInterval.split('~'):['08:00', '22:00']
            this.form.dateStart = exec[0]
            this.form.dateEnd = exec[1]
            this.form.dateType = execInterval?'2':'1'
          })
          // .finally(() => this.loading = false)
        } else {
          this.nowObj = null
        }
      })
    },
    validatorEmails(rule, value, callback) {
      if(!/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},*[\W]*)+$/.test(value) && this.form.receivers.emailCheck) {
        callback(new Error('请正确填写邮箱，以逗号分隔'))
      } else {
        callback()
      }
    },
    validatorFeiShuEmails(rule, value, callback) {
      if(!/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},*[\W]*)+$/.test(value) && this.form.receivers.feishuEmailCheck) {
        callback(new Error('请正确填写飞书邮箱，以逗号分隔'))
      } else {
        callback()
      }
    },
    handleOk(e) {
      this.$refs.form.validate(valid => {
        if (valid) {
          if(!this.form.receivers.emailCheck && !this.form.receivers.feishuEmailCheck){
            this.$message.warning('邮箱为必填选项')
            return false;
          }else {
            if(!this.form.receivers.emails && !this.form.receivers.feishuEmails){
              this.$message.warning('邮箱为必填选项')
              return false;
            }
          }
          // const { name, status,templateId, execFrequency,execDate } = this.form;
          const params = this.$deepclone(this.form);
          params.execInterval = params.dateType === '2'?`${params.dateStart}~${params.dateEnd}`:undefined
          if(params.execFrequency !== 'EVERY_HOUR') {
            params.execMinute = undefined
          }
          this.confirmLoading = true;
          let api = this.nowObj ? updateChartSub : addChartSub;
          api(params).then((res) => {
            // console.log(first)
            this.$message.success(`${this.nowObj?'编辑':'新增'}成功！`)
            this.visible = false
            this.reset()
            this.$emit('success')
          }).finally(() => this.confirmLoading = false)
        } else {
          return false;
        }
      });
    },
   
    handleCancel(e) {
      console.log(this.form)
      this.reset()
      this.visible = false;
    },
    reset() {
      this.form = this.$deepclone(initForm)
      this.$refs.form.clearValidate()
    },
    handleClearValidate() {
      this.$refs["form"].clearValidate([
        'formularStr',
        'sourceField',
        'sourceValEg',
        'fromIdx',
      ]);
    },
    // 字段类型change
    regulationChange() {
      this.form.name = ''
      this.form.status = false
      this.form.templateId = undefined
      this.form.execFrequency = ''
      this.form.execDate = ''
      this.form.emails = ''
      this.form.feishuEmails = ''
      this.form.emailCheck = false
      this.form.feishuEmailCheck = false
     
      // this.handleClearValidate()
    },

  },
  
};
</script>
<style lang="less" scoped>
.division-title {
  text-align: left;
  line-height: 40px;
  padding-right: 10px;
}
.delete-info {
  font-size: 16px;
  vertical-align: middle;
  margin-left: 10px;
}
.hour-range {
    padding-top: 4px;
    .anticon {
      margin-left: 10px;
    }
    .split-icon {
      margin-left: -5px;
      margin-right: -5px;
      &.is-check {
        margin-left: 5px;
        margin-right: 5px;
      }
    }
    /deep/ .ant-select {
      .ant-select-selection {
        background: transparent;
        box-shadow: none;
      }
      &:first-of-type {
        .ant-select-selection {
          border-right: 0px;
          border-top-right-radius: 0%;
          border-bottom-right-radius: 0%;
          .ant-select-selection__rendered {
            margin-right: 0px;
          }
        }
      }
      &:last-of-type {
        .ant-select-selection {
          border-left: 0px;
          border-top-left-radius: 0%;
          border-bottom-left-radius: 0%;
          .ant-select-selection__rendered {
            margin-right: 0px;
          }
        }
      }
    }
  }
</style>